import React from "react";
import StoreCheckbox from "./StoreCheckbox";

const BrandSelection = ({brands, title, selectedBrands, updateSelectedBrands}) => {
  return (
    <div>
      <fieldset className="row">
        <legend>{title}</legend>
        <p className="help-text">Select the brands you want displayed:</p>
        {
          brands.map(function(brand, index) {
            return(
              <StoreCheckbox key={brand.key} checked={selectedBrands[brand.key] !== false} brand={brand} updateSelectedBrands={updateSelectedBrands}/>
            );
          })
        }
      </fieldset>
    </div>
  );
};

BrandSelection.propTypes = {
  brands: React.PropTypes.array.isRequired,
  title: React.PropTypes.string.isRequired,
  selectedBrands: React.PropTypes.object.isRequired,
  updateSelectedBrands: React.PropTypes.func.isRequired
};

export default BrandSelection;



/** WEBPACK FOOTER **
 ** ./src/components/SettingsForm/BrandSelection.js
 **/